import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useTypedParams } from 'react-router-typesafe-routes';
import ForwardForm from '@/components/scan-code/forward-form';
import { getBatchMessagesMap } from '@/hooks/batch-message/use-get-batch-messages';
import useBatchForward, { type ForwardTarget } from '@/hooks/forward/use-batch-forward';
import ROUTES from '@/routes';

export default function ForwardBatchMessageRoute() {
  const { batchId } = useTypedParams(ROUTES.MY.SETTINGS.MESSAGING.BATCH.PREVIEW);
  const batchMessage = (getBatchMessagesMap() ?? {})[batchId];
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsyncWithPrompt, isPending: isForwarding } = useBatchForward();

  const handleForward = async (targets: ForwardTarget[], clearSelection: () => void) => {
    if (!batchMessage) return;
    if (await mutateAsyncWithPrompt({ urls: [{ url: batchMessage?.Message, type: batchMessage?.MsgType }], targets })) {
      navigate(-1);
      clearSelection();
    }
  };

  if (!batchMessage) return;

  return (
    <ForwardForm
      className='min-h-[80dvh] w-full'
      navigateBack
      onForward={handleForward}
      isLoading={isForwarding}
      title={t('conversation.forward.title')}
    />
  );
}
